<template>
  <div class="mt-5 flex flex-col gap-1">
    <QBtn
      v-for="menu in menus"
      :to="menu.route"
      dense
      :color="$q.dark.isActive?'dark-1':'light-3'"
    >
      <div class="w-full px-4 py-1 text-sm dark:text-dark-text light:text-light-text flex items-center justify-start gap-5">
        <SvgIcon
          :name="menu.icon"
          size="xs"
        />
        {{ menu.name }}
      </div>
    </QBtn>
  </div>
</template>

<script setup>
import SvgIcon from '@/components/Icons/SvgIcon.vue'

const menus = [
  {
    icon: 'prematches',
    name: '스포츠A (국내형)',
    route: { name: 'prematches' }
  },
  {
    icon: 'pregames',
    name: '스포츠B (유럽형)',
    route: { name: 'pregames' }
  },
  {
    icon: 'lives',
    name: '라이브',
    route: { name: 'lives' }
  },
  {
    icon: 'casinos',
    name: '카지노',
    route: { name: 'casinos' }
  },
  {
    icon: 'slots',
    name: '슬롯',
    route: { name: 'slots' }
  },
  {
    icon: 'mini-games',
    name: '미니게임',
    route: { name: 'mini-games' }

  },
  {
    icon: 'virtual-games',
    name: '가상게임',
    route: { name: 'virtual-games' }
  },
//  {
//    icon: 'graph-games',
//    name: '그래프게임',
//    route: { name: 'pragmatic', params: { id: 33, code: 1302 } },
//  },
  // {
  //   icon: 'prematches',
  //   name: '국내형스포츠',
  //   route: { name: 'prematches' }
  // },
  // {
  //   icon: 'duotone-balls',
  //   name: '로또6/45',
  //   route: { name: 'duotone-balls' }
  // }
]
</script>
